const zhTW = {
  // Navbar
  nav_home: "首頁",
  nav_about: "關於點點大叔",
  nav_services: "服務與價格",
  nav_flow: "服務流程",
  nav_testimonials: "用戶評價",
  nav_faq: "常見問題",
  nav_contact: "聯絡我們",
  nav_cta: "預約姓名鑑定",
  nav_subtitle: "姓名鑑定 · 沖繩",
  nav_title: "點點大叔鑑定所",

  // Hero
  hero_headline1: "在寧靜的",
  hero_headline2: "沖繩島嶼",
  hero_headline3: "聆聽你",
  hero_headline4: "名字的聲音。",
  hero_body: "預約排隊數月的熱門姓名鑑定。\n每個月我親自前往沖繩的島嶼，\n將您的名字傳達給大師。",
  hero_pill1: "無需改名",
  hero_pill2: "100% 線上",
  hero_pill3: "一個月內交付",
  hero_pill4: "每月前100名",
  hero_btn_apply: "預約姓名鑑定",
  hero_btn_services: "查看服務",
  hero_scroll: "向下滾動",

  // About
  about_heading: "關於點點大叔",
  about_intro: "在被沖繩溫柔海洋環繞的寧靜小島<strong>伊計島</strong>上，\n住著一位默默為每個名字添加一點光芒的人。\n人們親切地稱他為<strong>「點點大叔」</strong>。",
  about_block1_label: "從銀行家到姓名鑑定師",
  about_block1_text: "點點大叔最初是一名銀行家。\n憑藉勤奮努力，他成為公司<strong>最年輕的支行行長</strong>。\n在與眾多人打交道的過程中，他心中產生了一個疑問。",
  about_block1_quote: "「為什麼同樣努力工作，有些人卻彷彿乘風而行？」",
  about_block1_sub: "這個小小的疑問，成為了一段偉大探索之旅的起點。",
  about_block2_label: "古老智慧與寧靜的啟示",
  about_block2_text: "他將每一分空閒時間都用於研究古代姓名鑑定典籍，仔細探究傳統漢字的筆畫數量和音韻流動。",
  about_block2_text2: "他領悟到<strong>「濁點（てんてん）能夠悄悄調和名字的流動」</strong>。",
  about_block2_sub: "這不是戲劇性的魔法，也不是華而不實的成功公式，\n而是一條溫柔的道路，讓人內心已有的光芒更加清晰可見。",
  about_block3_label: "口耳相傳——如今需等待6個月",
  about_block3_text: "他溫柔的鑑定完全通過口耳相傳傳播，如今<strong>來自全日本的諮詢絡繹不絕</strong>。\n無論對方是否有名氣，他都以同樣的關懷對待每一個人。\n他將手放在每個名字上，陪伴那個人的人生。\n這就是點點大叔的風格。",

  // Gallery
  gallery_heading: "圖片展示",
  gallery_sub: "沖繩 · 伊計島",

  // Services
  services_heading: "服務與價格",
  services_note1: "※ 所有套餐均包含大師鑑定費及我們的現場代理服務費。",
  services_note2: "※ 無任何額外費用。請放心委託。",
  services_tab1: "個人姓名",
  services_tab2: "商號名稱",
  services_tab3: "寵物名字",
  services_tab1_en: "Personal Name",
  services_tab2_en: "Business Name",
  services_tab3_en: "Pet Name",
  services_tab1_desc: "我們溫柔地觀察您的成長、環境和內心動向，為您添加最適合的濁點。",
  services_tab2_desc: "為新的挑戰帶來溫柔的順風。悄悄調和您事業的流動。",
  services_tab3_desc: "為始終陪伴在您身邊的家庭成員。賦予充滿安寧與溫暖的名字。",
  services_row1_target1: "16歲及以上",
  services_row1_target2: "4至15歲",
  services_row1_target3: "0至3歲",
  services_row2_target1: "商號 / 公司 / 店鋪名稱",
  services_row3_target1: "寵物名字",
  services_col_target: "適用對象",
  services_col_price: "價格（含稅）",
  services_cta: "預約此服務",
  services_includes_title: "包含內容（全部含在價格內）",
  services_inc1: "姓名鑑定",
  services_inc2: "最佳濁點建議",
  services_inc3: "名片尺寸卡片郵寄（免費，按需）",
  services_inc4: "開運建議",
  services_inc5: "姓名卡片數碼照片",
  services_includes_note: "鑑定旨在溫柔地彰顯您名字中已有的魅力。",
  services_payment_title: "付款方式",
  services_payment_method: "銀行轉帳（預付款）",
  services_payment_desc: "申請後我們將提供銀行帳戶資訊。\n付款完成後，好運的流動將悄然開始匯聚。",
  services_first_title: "初次來訪的朋友",
  services_first_desc: "感到不安是很自然的。\n這種感覺是您內心的信號，\n提示您是時候開始溫柔的改變了。",
  services_first_cta: "從諮詢開始",

  // Flow
  flow_heading: "服務流程",
  flow_step1_title: "提交申請表",
  flow_step1_c1: "請在專用表格中填寫必要資訊。",
  flow_step1_c2: "提交後，我們將在2至3個工作日內回覆您。",
  flow_step1_c3: "郵件中將說明後續步驟及銀行轉帳說明。",
  flow_step2_title: "轉帳支付鑑定費",
  flow_step2_c1: "請將鑑定費轉帳至回覆郵件中指定的帳戶。",
  flow_step2_c2: "確認收款後，我們將按順序開始準備您的鑑定。",
  flow_step3_title: "通知我們轉帳完成",
  flow_step3_c1: "轉帳後，請將收據照片發送至郵件中指定的地址。",
  flow_step3_c2: "確認後，我們將向您發送「登記完成」的訊息。",
  flow_step3_note: "若未收到此通知，我們可能無法開始您的鑑定。請務必發送。",
  flow_step4_title: "接收鑑定結果",
  flow_step4_c1: "鑑定完成後約一週，我們將透過電子郵件發送姓名卡片及濁點的照片。",
  flow_step4_c2: "隨後，我們將透過電子郵件發送詳細的鑑定報告和開運建議。",
  flow_step5_title: "寄送姓名卡片（可選）",
  flow_step5_c1: "應要求，我們將郵寄大師手寫的名片尺寸卡片。",
  flow_step5_c2: "請在申請表的地址欄中填寫準確的郵寄地址。",
  flow_step5_note: "如不需要卡片，填寫您所在城市即可。",
  flow_banner_title: "全程線上。來自日本任何地方。",
  flow_banner_desc: "無需前往沖繩伊計島。\n您可以在不改變日常生活的情況下立即開始。",
  flow_banner_cta: "立即申請",

  // Testimonials
  testimonials_heading: "用戶評價",
  testimonials_viewing: "正在查看",

  // FAQ
  faq_heading: "常見問題",
  faq_cta_title: "還有其他問題？",
  faq_cta_desc: "歡迎提出任何小問題。\n那些您不好意思開口的問題——正是我們最想聽到的。",
  faq_cta_btn: "向我們提問",

  // CTA Banner
  cta_heading1: "免費",
  cta_heading2: "諮詢",
  cta_btn: "立即預約",

  // Contact
  contact_heading: "聯絡我們",
  contact_desc: "請透過此表格提交鑑定申請或諮詢。我們通常在2至3個工作日內回覆。",
  contact_address_label: "地址",
  contact_address_value: "日本栃木縣（線上 · 全國對應）",
  contact_email_label: "電子郵件",
  contact_hours_label: "營業時間",
  contact_hours_value: "週一至週五 9:00–18:00（週六/週日/節假日休息）",
  contact_note_title: "關於回覆",
  contact_note_desc: "我們的回覆可能會進入垃圾郵件資料夾。\n如果您在2至3個工作日內未收到回覆，請直接透過電子郵件聯絡我們。",
  contact_field_name: "姓名",
  contact_field_furigana: "假名（讀音）",
  contact_field_email: "電子郵件地址",
  contact_field_phone: "電話號碼",
  contact_field_service: "希望的服務",
  contact_field_message: "留言",
  contact_placeholder_name: "王小明",
  contact_placeholder_furigana: "ヤマダ タロウ",
  contact_placeholder_email: "example@mail.com",
  contact_placeholder_phone: "+886 000 000 0000",
  contact_placeholder_message: "請輸入您希望鑑定的姓名，或您的問題和需求。",
  contact_select_placeholder: "請選擇",
  contact_service1: "個人姓名",
  contact_service2: "商號名稱",
  contact_service3: "寵物名字",
  contact_service4: "其他 / 諮詢",
  contact_submit: "提交",
  contact_submitting: "提交中...",
  contact_privacy: "透過表格提交的個人資訊將僅用於姓名鑑定服務。",
  contact_error: "提交失敗。請稍後再試，或直接透過電子郵件聯絡我們。",
  contact_err_name: "請輸入您的姓名",
  contact_err_email_required: "請輸入電子郵件地址",
  contact_err_email_invalid: "請輸入有效的電子郵件地址",
  contact_err_service: "請選擇服務",
  contact_err_message_required: "請輸入留言內容",
  contact_err_message_limit: "留言請限制在500字以內",
  contact_thanks_title: "訊息已發送",
  contact_thanks_desc: "感謝您的聯絡。\n我們將審閱您的訊息，並在<strong>2至3個工作日</strong>內回覆您。\n請稍候。",
  contact_thanks_check1: "請查收確認郵件",
  contact_thanks_check2: "請同時檢查垃圾郵件資料夾",
  contact_thanks_check3: "請等待2至3個工作日的回覆",
  contact_thanks_another: "再次發送訊息",

  // Footer
  footer_subtitle: "姓名鑑定 · 沖繩",
  footer_title: "點點大叔鑑定所",
  footer_desc: "從沖繩到全日本。擁有50年以上經驗的姓名鑑定大師，用心解讀您名字中的命運。",
  footer_contact_title: "聯絡資訊",
  footer_address_label: "地址",
  footer_address_value: "日本栃木縣\n（線上 · 全國對應）",
  footer_email_label: "郵件",
  footer_hours_label: "營業時間",
  footer_hours_value: "週一至週五 9:00–18:00\n（週六/週日/節假日休息）",
  footer_nav_title: "導覽",
  footer_copyright: "© 2025 點點大叔鑑定所 版權所有。",
  footer_privacy: "隱私政策",
  footer_law: "特定商取引法",
  footer_sitemap: "網站地圖",
};

export default zhTW;
